import _ from 'underscore';
import { getGTMSessionType } from './gtm-app-cohort-provider';

const getGoogleSessionUrlTmpl = 'ImportSession/StartGoogleSession(CustomerId=:customer_id,AccountId=:account_id)?authCode={{AuthCode}}&sessionType={{GTMSessionType}}&redirectUri=postmessage';
const getGoogleSessionWithTokenUrlTmpl = 'ImportSession/StartGoogleSession(CustomerId=:customer_id,AccountId=:account_id)?refreshToken={{Token}}&sessionType={{GTMSessionType}}&redirectUri=postmessage';

const getGoogleLoginEmailUrlTmpl = 'ImportSession/GoogleLoginEmail(CustomerId=:customer_id,AccountId=:account_id,SessionId={{SessionId}})?sessionType={{GTMSessionType}}';

const getGTMAccountsUrlTmpl = 'ImportSession/GTMAccounts(CustomerId=:customer_id,AccountId=:account_id,SessionId={{SessionId}})';
const getGTMAccountsUrlMultiAppTmpl = 'ImportSession/GTMAccounts(CustomerId=:customer_id,AccountId=:account_id,SessionId={{SessionId}})?sessionType={{GTMSessionType}}';

const getGTMContainersUrlTmpl = 'ImportSession/GTMContainers(CustomerId=:customer_id,AccountId=:account_id,SessionId={{SessionId}})?GTMAccountId={{GTMAccountId}}';
const getGTMContainersUrlMultiAppTmpl = 'ImportSession/GTMContainers(CustomerId=:customer_id,AccountId=:account_id,SessionId={{SessionId}})?GTMAccountId={{GTMAccountId}}&sessionType={{GTMSessionType}}';

const getCreateTaskItemExecutionUrlTmpl = '/Customers()/Accounts()/TaskItems?%24expand=TaskItemExecutions';
const getPollTaskItemExecutionUrlTmpl = '/Customers()/Accounts()/TaskItemExecutions({{taskItemExecutionId}})';

export class GoogleTagManagerReporitory {
  constructor(deps) {
    this.deps = deps;
    this.odata = deps.odata;
    this.useMultiApps = deps.permissions && deps.permissions.IsGTMMultiAppSupportEnabled;
    this.sessionType = getGTMSessionType(this.useMultiApps);
  }

  startGoogleSession(authCode) {
    const url = getGoogleSessionUrlTmpl.replace('{{AuthCode}}', authCode).replace('{{GTMSessionType}}', this.sessionType);

    return this.odata.post(url, { data: '' });
  }

  startGoogleSessionWithToken(token) {
    const url = getGoogleSessionWithTokenUrlTmpl.replace('{{Token}}', token).replace('{{GTMSessionType}}', this.sessionType);

    return this.odata.post(url, { data: '' });
  }

  fetchGoogleLoginEmail = (sessionId) => {
    const url = getGoogleLoginEmailUrlTmpl.replace('{{SessionId}}', sessionId).replace('{{GTMSessionType}}', this.sessionType);

    return this.odata.get(url);
  };

  getGTMAccounts(sessionId) {
    const baseUrl = this.useMultiApps ? getGTMAccountsUrlMultiAppTmpl : getGTMAccountsUrlTmpl;
    const url = baseUrl.replace('{{SessionId}}', sessionId).replace('{{GTMSessionType}}', this.sessionType);

    return this.odata.get(url);
  }

  getGTMContainers(sessionId, GTMAccountId) {
    const baseUrl = this.useMultiApps ? getGTMContainersUrlMultiAppTmpl : getGTMContainersUrlTmpl;
    const url = baseUrl.replace('{{SessionId}}', sessionId).replace('{{GTMAccountId}}', GTMAccountId).replace('{{GTMSessionType}}', this.sessionType);

    return this.odata.get(url);
  }

  createGTMImportTaskItem(taskItem, isCustomerLevel = false) {
    const url = getCreateTaskItemExecutionUrlTmpl;
    const finalTaskItem = {
      ...taskItem,
      GTMImportContext: {
        ...taskItem.GTMImportContext,
        IsCustomerLevel: isCustomerLevel,
      },
    };

    if (this.useMultiApps) {
      finalTaskItem.GTMImportContext.GoogleAppClientId = this.sessionType;
    }

    return this.odata.post(url, { data: finalTaskItem });
  }

  pollTaskExecutionStatus(taskItemExecutionId) {
    const url = getPollTaskItemExecutionUrlTmpl.replace('{{taskItemExecutionId}}', taskItemExecutionId);

    return this.pollStatus(url);
  }

  pollStatus(url) {
    return new Promise((resolve, reject) => {
      const MAX_FAILED_ATTEMPTS = 5;
      const MAX_INCOMPLETE_ATTEMPTS = 7;
      let failedAttempts = 0;
      let incompleteAttempts = 0;
      let lastCallCompleted = true;

      function onCheckStatusSuccess(data) {
        if (data.Status === 'Failed' || data.Status === 'Completed') {
          // stop polling and reject/resolve
          clearInterval(this.timeout);
          if (data.Status === 'Completed' && (!data.ErrorCode || _.isEmpty(data.ErrorCode))) {
            resolve(data);
          } else {
            const err = new Error();

            err.customized = {
              errorCode: data.ErrorCode,
              errorDetail: data.ErrorDetail,
            };
            reject(err);
          }
        } else {
          incompleteAttempts += 1;
          if (incompleteAttempts === MAX_INCOMPLETE_ATTEMPTS) {
            clearInterval(this.timeout);
            resolve(data);
          }
        }
      }

      function checkStatus() {
        if (lastCallCompleted) {
          lastCallCompleted = false;
          this.odata.get(url)
            .then((data) => {
              onCheckStatusSuccess.call(this, data);
            })
            .catch((err) => {
              failedAttempts += 1;
              if (failedAttempts === MAX_FAILED_ATTEMPTS) {
                clearInterval(this.timeout);
                reject(err);
              }
            })
            .finally(() => {
              lastCallCompleted = true;
            });
        }
      }
      this.timeout = setInterval(checkStatus.bind(this), 1500);
    });
  }
}
